export interface Coordinates {
	lat: number;
	lng: number;
}

export function toFiniteCoordinates(
	lat: unknown,
	lng: unknown
): Coordinates | undefined {
	return typeof lat === 'number' &&
		typeof lng === 'number' &&
		Number.isFinite(lat) &&
		Number.isFinite(lng)
		? { lat, lng }
		: undefined;
}

// Production rule: any truthy pair counts, so 0 is "no point". Kept as is for the legacy SRP.
export function toTruthyCoordinates(
	lat?: number,
	lng?: number
): Coordinates | undefined {
	return lat && lng ? { lat, lng } : undefined;
}
